import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, from, map, Observable, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { S3Client } from "@aws-sdk/client-s3-browser";

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private baseUrl = environment.baseUrl;

  private s3: S3Client;
  private bucketName = 'sparklycards-bucket';
  private endpoint = 'https://5006aef2a709ec4d312b6a727f18d80a.eu.r2.cloudflarestorage.com';
  private region = 'auto';
  private credentials = {
    accessKeyId: '5a5eae67006c6930c2f3d764dc43ed0e',
    secretAccessKey: '7758a10d8316b098775d276d3b2c749b609b79364dd5841a4d015136ba1a7aa3',
  };

  constructor(private http: HttpClient) {
    this.s3 = new S3Client({
      region: this.region,
      endpoint: this.endpoint,
      credentials: this.credentials,
      forcePathStyle: true, // WICHTIG für R2 in Angular
    });
  }

  private getSignedUrl(fileType: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/file/signed-url`, { fileType });
  }

  uploadFile(file: File): Observable<{ fileName: string }> {
    return this.getSignedUrl(file.type).pipe(
      switchMap(response => from(fetch(response.signedUrl, {
        method: 'PUT',
        body: file,
        headers: { 'Content-Type': file.type },
      })).pipe(
        map(() => ({ fileName: response.fileName })),
        catchError(err => throwError(() => new Error('Fehler beim Hochladen')))
      ))
    );
  }

  getSignedAccessUrl(resourceId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/resources/${resourceId}/file-access-url`);
  }

  generateFlashcardsFromFile(fileNames: string[], userPrompt: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/file/generate-flashcards`, { fileNames, userPrompt });
  }

  uploadFileContents(courseId: number, filesContents: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/file/content`, { courseId, filesContents });
  }

  getFiles(courseId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/file/` + courseId);
  }

  deleteFile(fileId: number) {
    return this.http.delete<any>(`${this.baseUrl}/file/${fileId}`);
  }
}
